export enum FormType {
  Consent = 1,
  Treatment = 2,
  Intake = 3,
  Other = 4,
}

export const formTypeNames = new Map([
  [FormType.Consent, 'Consent'],
  [FormType.Treatment, 'Treatment'],
  [FormType.Intake, 'Intake'],
  [FormType.Other, 'Other'],
]);
